import React from 'react';
import { Helmet } from 'react-helmet';
import { Button } from '@components';
import { useNavigate } from 'react-router-dom';
import { AnoMesReferencia } from '../components';

export const ExtratoContaAposentadoriaPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Forluz - Emitir Extrato da Conta de Aposentadoria</title>
      </Helmet>
      <h1 className="page-title mb-3">
        <strong>Emitir Extrato da Conta de Aposentadoria</strong>
      </h1>
      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      <AnoMesReferencia
        buscaPorPeriodo={({ mesSelecionado, anoSelecionado }) =>
          console.log(`Ano: ${mesSelecionado} Mes: ${anoSelecionado}`)
        }
      />
    </>
  );
};
